// extracted by mini-css-extract-plugin
export var copyIcon = "_yw-2";
export var discountCard = "_yw-0";
export var discountCode = "_yw-3";
export var discountContent = "_yw-1";
export var loadingCard = "_yw-4";